import type { ReactNode } from 'react';
import { ThemeProvider } from '@/contexts/ThemeContext';

function AuthLayoutInner({ children, headingId }: { children: ReactNode; headingId: string }) {
  return (
    <main
      aria-labelledby={headingId}
      className="flex min-h-screen items-center justify-center bg-background px-6 py-10 sm:px-8"
    >
      <div className="w-full max-w-md">
        {children}
      </div>
    </main>
  );
}

export function AuthLayout({ children, headingId }: { children: ReactNode; headingId: string }) {
  return (
    <ThemeProvider>
      <AuthLayoutInner headingId={headingId}>{children}</AuthLayoutInner>
    </ThemeProvider>
  );
}
